import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IIroNamRequest, IroNamRequestStatus, IUser, RequestState } from '@shs-digi-care-monorepo/interfaces';
import {
    TableComponent,
    TableHeadComponent,
    TableHeaderComponent,
    TableRowComponent,
    TableCellComponent,
    MobileRowFieldComponent,
    MobileTableCardComponent,
    MobileTableComponent,
    SortOrder,
    statusPillColorMap
} from '@shs-digi-care-monorepo/frontend-lib';
import { TableDateCellComponent } from '../table-date-cell/table-date-cell.component';
import { TabFilterState } from '../../state/tab-filter-state';
import { AssignToMeButtonComponent } from '../assign-to-me-button/assign-to-me-button.component';

/** Statuses that do not have an assignee yet */
const PRE_ASSIGNMENT_STATUSES: Set<string> = new Set([IroNamRequestStatus.SAVED, IroNamRequestStatus.SUBMITTED]);

@Component({
    selector: 'app-mdla-requests-table',
    templateUrl: './mdla-requests-table.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        TableComponent,
        TableHeadComponent,
        TableHeaderComponent,
        TableRowComponent,
        TableCellComponent,
        AssignToMeButtonComponent,
        MobileRowFieldComponent,
        MobileTableCardComponent,
        MobileTableComponent,
        TableDateCellComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MdlaRequestsTableComponent {
    public tasks = input.required<IIroNamRequest[]>();
    public loading = input.required<boolean>();
    public total = input.required<number>();
    public activeState = input.required<TabFilterState>();

    public sortChange = output<{ column: string; order: SortOrder | null }>();
    public assigned = output<{ request: IIroNamRequest; user: IUser }>();

    protected statusPillColorMap = statusPillColorMap;
    protected requestStatusEnum = IroNamRequestStatus;

    protected readonly showAssigneeColumn = computed(() => {
        const statuses = this.activeState().statusFilterValue();
        if (statuses.length === 0) {
            return true;
        }
        return statuses.some((s) => !PRE_ASSIGNMENT_STATUSES.has(s));
    });

    protected showAssignToMeColumn = computed(() =>
        this.activeState().statusFilterValue().includes(RequestState.SUBMITTED)
    );
}
